const round = (value, precision = 0) => {
  return Math.round(value * 10 ** precision) / 10 ** precision;
};

export default round;
